<template>
  <b-card>
    <validation-observer v-slot="{ invalid }">
      <b-form>
        <b-row>
          <EntityEditSection
            :entity="entity"
            :form-fields="fields"
            module=""
            allow-autofocus
          />
          <b-col cols="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mt-0 mr-1"
              :disabled="invalid"
              @click.prevent="submitForm"
            >
              {{ $t('Save Changes') }}
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="reset"
              class="mt-0"
              variant="outline-secondary"
              @click.prevent="reloadData"
            >
              {{ $t('Reset') }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import {
  BButton, BForm, BRow, BCol, BCard,
} from 'bootstrap-vue'
import { ValidationObserver } from 'vee-validate'
import Ripple from 'vue-ripple-directive'
import EntityEditSection from '@/layouts/entity/EntityEditSection.vue'

export default {
  components: {
    BButton,
    BForm,
    BRow,
    BCol,
    BCard,
    ValidationObserver,
    EntityEditSection
  },
  directives: {
    Ripple,
  },
  props: {
    userData: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      entity: JSON.parse(JSON.stringify(this.userData)),
      prefectureOptions: [],
      positionOptions: [],
      clinicOptions: [],
      hospitalOptions: [],
    }
  },
  computed: {
    fields() {
      return [
        {
          id: 'bio',
          type: 'quill',
          label: this.$t('bio'),
          colSize: 12,
        },
        {
          id: 'jobTelephone',
          label: this.$t('telephonebusiness'),
          rules: 'phone',
        },
        {
          id: 'companyName',
          label: this.$t('company name'),
        },
        {
          id: 'vatId',
          label: this.$t('vatId'),
        },
        {
          id: 'vatOffice',
          label: this.$t('vat office'),
        },
        {
          id: 'hospital',
          object: true,
          type: 'select',
          label: this.$t('hospital'),
          options: this.hospitalOptions,
        },
        {
          id: 'clinic',
          object: true,
          type: 'select',
          label: this.$t('clinic'),
          options: this.clinicOptions,
        },
        {
          id: 'jobPosition',
          object: true,
          type: 'select',
          label: this.$t('JobPosition'),
          options: this.positionOptions,
        },
        {
          id: 'jobPrefecture',
          object: true,
          type: 'select',
          label: this.$t('JobPrefecture'),
          options: this.prefectureOptions,
          colSize: 6,
        },
        {
          id: 'privateOffice',
          type: 'checkbox',
          label: this.$t('PrivateOffice'),
          colSize: 2,
        },
        {
          id: 'privateClinic',
          type: 'checkbox',
          label: this.$t('PrivateClinic'),
          colSize: 2,
        },
        {
          id: 'professionalTitle',
          type: 'quill',
          label: this.$t('professional title'),
          colSize: 12,
        },
      ].map(field => ({
        ...field,
        type: field.type || 'text',
        parent: 'participant',
        class: 'mt-0',
        required: false,
        colSize: field.colSize || 6,
      }))
    },
  },
  mounted() {
    this.$store.dispatch('app-common/fetchPrefectures').then((response) => {
      this.prefectureOptions = response.data
    })
    this.$store.dispatch('app-common/fetchJobPositions').then((response) => {
      this.positionOptions = response.data
    })
    this.$store.dispatch('app-common/fetchClinics').then((response) => {
      this.clinicOptions = response.data
    })
    this.$store.dispatch('app-common/fetchHospitals').then((response) => {
      this.hospitalOptions = response.data
    })
  },
  methods: {
    reloadData() {
      this.entity = JSON.parse(JSON.stringify(this.userData))
    },

    submitForm() {
      this.$emit('formSubmitted', {
        ...this.entity,
      })
    },
  },
}
</script>
